(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth < 991) {
    new Swiper('.collection-slider-mobile', {
      slidesPerView: 1.3,
      spaceBetween: 20,
      slidesPerView: 'auto',
      centeredSlides: false,
      breakpoints: {
        480: {
          slidesPerView: 1.3
        },
        768: {
          slidesPerView: 2.2
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".vertical-slider-container", {
    direction: "vertical",
    slidesPerView: 1,
    speed: 800,
    mousewheel: {
      forceToAxis: true,       // makes scroll direction strict
      sensitivity: 0.5,        // adjust for trackpads
      releaseOnEdges: false,   // prevent page scroll on last slide
      thresholdDelta: 50,      // require strong enough scroll
      thresholdTime: 500       // delay between scrolls
    },
    keyboard: {
      enabled: true
    },
    touchReleaseOnEdges: false
  });

  // Completely disable scroll bubbling to page
  window.addEventListener('wheel', function (e) {
    e.preventDefault();
  }, { passive: false });

  window.addEventListener('touchmove', function (e) {
    e.preventDefault();
  }, { passive: false });

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-slider"] && !Shopify.designMode) return;
  try {
    
    $(function () {
      $.scrollify({
        section: ".vertical-slider-container .section",
        scrollSpeed: 1200,
        easing: "easeOutExpo",
        overflowScroll: true,
        setHeights: false,
        updateHash: false,
        touchScroll: true,
        interstitialSection: ".shopify-section-group-footer-group"
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var totalSlides = document.querySelectorAll('.video-reel .swiper-slide').length;

    var swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 18,
      breakpoints: {
        // Mobile first
        0: {
          slidesPerView: totalSlides > 1 ? 2 : 1,
          spaceBetween: 18,
          // use percentage width
          slidesPerView: 'auto',
        },
        // Tablet
        768: {
          slidesPerView: totalSlides > 2 ? 3 : totalSlides,
          spaceBetween: 18,
        },
        // Desktop
        1024: {
          slidesPerView: totalSlides > 5 ? 5 : totalSlides,
          spaceBetween: 18,
        }
      }
    };

    new Swiper('.video-reel', swiperOptions);
  });

  // Video Review ALL JS
  //   if( jQuery('.video_reviews .slider.videos').length ){ // video center mode reviews
  //       jQuery('.video_reviews .slider.videos').slick({
  //         mobileFirst: true,
  //         dots: false,
  //         infinite: false,
  //         loop: false,
  //         slidesToShow: 1,
  //         nextArrow: jQuery('.video_reviews .arrows .next'),
  //         prevArrow: jQuery('.video_reviews .arrows .prev'),
  //         responsive: [
  //           {
  //             breakpoint: 640,
  //             settings:{
  //               slidesToShow: 4,
  //               infinite: false,
  //               loop: false,
  //             }          
  //           }
  //         ]
  //       });
    
  //       jQuery('.video_reviews .slider.videos').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //         var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
  //         jQuery('.video_reviews .slider.videos button[data-state="pause"]').click();
      
  //         jQuery('.video_reviews .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
  //         jQuery('.video_reviews .progress .slider__label').text( calc + '% completed' );
  //       });
      
  //     jQuery('.video_reviews .video button[data-state="play"]').click(function(){
  //       var $this = jQuery(this).parent('div');
  //       var video = $this.find('video').get(0);
    
  //       video.play();
  //       jQuery(this).fadeOut();
  //       $this.find('button[data-state="pause"]').fadeIn();
    
  //     });
  //     jQuery('.video_reviews .video button[data-state="pause"]').click(function(){
  //       var $this = jQuery(this).parent('div');
  //       var video = $this.find('video').get(0);
    
  //       video.pause();
  //       jQuery(this).fadeOut();
  //       $this.find('button[data-state="play"]').fadeIn();
    
  //     });
    
  //     jQuery('.video_reviews .video').mouseenter(function(){
  //       var $this = jQuery(this);
  //       var video = $this.find('video').get(0);
  //       if( !video.paused ){
  //         jQuery(this).find('button[data-state="pause"]').fadeIn();
  //       }
  //     });
    
  //     jQuery('.video_reviews .video').mouseleave(function(){
  //       var $this = jQuery(this);
  //       var video = $this.find('video').get(0);
  //       if( !video.paused ){
  //         jQuery(this).find('button').fadeOut();
  //       } else{
  //         jQuery(this).find('button[data-state="play"]').fadeIn();
  //       }
  //     });
  // }
    // Video Review ALL JS END

  } catch(e) { console.error(e); }
})();
})();
